import React, { Component } from 'react';
import Boroughs from '../static/data/boroughs';
import Neighborhood_Labels from '../static/data/neighborhood_labels';
import Borough_Labels from '../static/data/borough_labels';
import HoverInfo from './HoverInfo'
import {min, max} from 'd3-array';
import extent from 'turf-extent';

class Map extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hover_info: false,
      map_ready: false
    }
  }

  getBoundingBox(feature) {
    var input = {
      "type": "FeatureCollection",
      "features": [
        feature
      ]
    }
    let box = extent(input);
    return box;
  }

  setHoverInfo(hover_info) {
    const {active_neighborhood} = this.props;
    if (hover_info) {
      hover_info.active_neighborhood = active_neighborhood;
    }
    this.setState({
      hover_info: hover_info
    })
  }

  addBoroughsLayer(map) {
    map.addSource('boroughs', {
      type: 'geojson',
      data: Boroughs
    }).addLayer({
      "id": "boroughs",
      "type": "fill",
      "source": "boroughs",
      "paint": {
          "fill-color": "#eee"
      },
      "layout": {
        "visibility": "none"
      }
    }, 'landuse_overlay_national_park');
  }

  getPaint(active_mode) {
    const price_focus = parseFloat(this.props.price_focus);
    let paint;
    if (active_mode === 'Chance') {
      paint = {
        'property': 'probability',
        stops: [
          // [0, '#efefef'],
          [0, '#fff'],
          // [0, '#d01c8b'],
          // [0.5, '#f7f7f7'],
          // [1, '#4dac26']
          // [1, '#6237ea']
          [1, '#866ff2']
        ]
      }
    } else if (active_mode === 'Price') {
      paint = {
        'property': 'price',
        stops: [
          // [0,'#5e3c99'],
          // [1000000, '#f7f7f7'],
          [0,'#ffffff'],
          [2000000,'#e66101']
        ]
      }
    }
    return paint;
  }

  handleMouseLeave() {
    const {map} = this.props;
    if (map) {
      this.setHoverInfo(false);
      if (map.getSource('hover')) {
        map.getSource('hover').setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    }
  }

  addHoverListener(map) {
    map.on('mousemove', (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['neighborhoods_layer']
      });
      const hex_features = map.queryRenderedFeatures(e.point, {
        layers: ['hexes_layer']
      });
      if (hex_features.length) {
        map.getCanvas().style.cursor = 'pointer';
        const hex_feature = hex_features[0];
        this.setHoverInfo({
          point: e.point,
          properties: hex_feature.properties
        });
        map.getSource('hover').setData({
          type: 'FeatureCollection',
          features: []
        });
        map.getSource('hex_hover').setData({
          type: 'FeatureCollection',
          features: [hex_feature]
        });
      } else if (features.length) {
        map.getCanvas().style.cursor = 'pointer';
        const feature = features[0];
        const neighborhood_names = this.props.neighborhoods.map(neighborhood => neighborhood.properties.neighborhood);
        const feature_index = neighborhood_names.indexOf(feature.properties.neighborhood);
        const full_feature = this.props.neighborhoods[feature_index];
        this.setHoverInfo({
          point: e.point,
          properties: feature.properties
        });
        map.getSource('hover').setData({
          type: 'FeatureCollection',
          features: [full_feature]
        });
        map.getSource('hex_hover').setData({
          type: 'FeatureCollection',
          features: []
        });
      } else {
        this.setHoverInfo(false);
        map.getSource('hover').setData({
          type: 'FeatureCollection',
          features: []
        });
        map.getSource('hex_hover').setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    });
    map.on('click', (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['neighborhoods_layer']
      });
      const hex_features = map.queryRenderedFeatures(e.point, {
        layers: ['hexes_layer']
      });
      if (hex_features.length) {
        const hex_feature = hex_features[0];
        this.props.setActiveHex(hex_feature.properties.hexid)
      } else if (features.length) {
        const feature = features[0];
        this.props.setActiveHex(false);
        if (this.props.active_neighborhood && this.props.active_neighborhood.properties.neighborhood === feature.properties.neighborhood) {
          // Already active
        } else {
          this.props.setActiveNeighborhood(feature.properties.neighborhood);
        }
      } else {
        this.props.setActiveHex(false)
        this.props.setActiveNeighborhood(false);
      }
    })
  }

  addNeighborhoodsLayer(map, browser_width) {
    const {active_year, active_mode, active_neighborhood, borough_filter, active_hex, neighborhoods} = this.props;
    const paint = this.getPaint(active_mode);
    map.addSource('neighborhoods', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": neighborhoods
      }
    }).addLayer({
      id: 'neighborhoods_layer',
      type: 'fill',
      source: 'neighborhoods',
      paint: {
        'fill-color': paint,
        'fill-outline-color': 'rgba(255,255,255,0.25)',
      }
    }, 'landuse_overlay_national_park');
    map.addSource('hover', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": []
      }
    }).addLayer({
      'id': 'hover',
      'source': 'hover',
      'type': 'line',
      'paint': {
        'line-color': '#222',
        'line-width': {
          "stops": [
            [12, 1],
            [14, 6]
          ]
        }
      }
    });
    this.addHoverListener(map);
    map.addSource('borough_labels', {
      type: 'geojson',
      data: Borough_Labels
    }).addLayer({
      "id": "borough_labels",
      "type": "symbol",
      "maxzoom": 10,
      "source": "borough_labels",
      "layout": {
          "visibility": "visible",
          "text-field": "{name}",
          "text-size": {
              "base": 1,
              "stops": [
                  [
                      0,
                      8
                  ],
                  [
                      12,
                      16
                  ],
                  [
                      22,
                      30
                  ]
              ]
          }
      },
      "paint": {
        "text-halo-color": "rgba(255,255,255,0.75)",
        "text-halo-width": 2
      }
    });
    map.addSource('hexes', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": []
      }
    }).addLayer({
      id: "hexes_layer",
      source: "hexes",
      type: "fill",
      paint: {
        'fill-color': paint,
        'fill-outline-color': '#222'
      }
    }, 'landuse_overlay_national_park');
    map.addSource('hex_hover', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": []
      }
    }).addLayer({
      'id': 'hex_hover',
      'source': 'hex_hover',
      'type': 'line',
      'paint': {
        'line-color': '#222',
        'line-width': {
          "stops": [
            [12, 1],
            [14, 6]
          ]
        }
      }
    });
    map.addSource('neighborhood_labels', {
      type: 'geojson',
      data: Neighborhood_Labels
    }).addLayer({
      "id": "neighborhood_labels",
      "type": "symbol",
      "source": "neighborhood_labels",
      "minzoom": 10,
      "layout": {
          "visibility": "visible",
          "text-field": "{name}",
          "text-size": {
              "base": 1,
              "stops": [
                  [
                      0,
                      8
                  ],
                  [
                      10,
                      10.5
                  ],
                  [
                      22,
                      22
                  ]
              ]
          }
      },
      "paint": {
        "text-color": "rgba(0,0,0,0.8)",
        "text-halo-color": "rgba(255,255,255,0.75)",
        "text-halo-width": 1
      }
    });
    map.addSource('active_borough', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": []
      }
    }).addLayer({
      'id': 'active_borough',
      'source': 'active_borough',
      'type': 'line',
      'paint': {
        'line-color': '#222',
        'line-width': {
          "stops": [
            [11, 1],
            [14, 4]
          ]
        }
      }
    });
    map.addSource('active', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": []
      }
    }).addLayer({
      'id': 'active',
      'source': 'active',
      'type': 'line',
      'paint': {
        'line-color': '#222',
        'line-width': {
          "stops": [
            [11, 2],
            [14, 8]
          ]
        }
      }
    });
    map.addSource('active_hex', {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features": []
      }
    }).addLayer({
      'id': 'active_hex',
      'source': 'active_hex',
      'type': 'line',
      'paint': {
        'line-color': '#222',
        'line-width': {
          "stops": [
            [11, 2],
            [14, 6]
          ]
        }
      }
    });
    if (active_neighborhood) {
      this.renderActiveNeighborhood(map, active_neighborhood, browser_width);
      this.props.getNeighborhoodHexes(active_neighborhood.properties.neighborhood)
      this.renderActiveBorough(map, borough_filter, active_neighborhood);
    } else if (borough_filter) {
      this.renderActiveBorough(map, borough_filter, active_neighborhood);
    } else {
      const nyc_bounds = [[-74.27643833007856, 40.48198566721396],[-73.65160461861605, 40.92793497349999]];
      map.fitBounds(nyc_bounds, {padding: 0});
    }
  }

  renderHexes(map, hexes) {
    if (hexes) {
      map.getSource('hexes').setData({
        type: 'FeatureCollection',
        features: hexes
      })
    } else {
      map.getSource('hexes').setData({
        type: 'FeatureCollection',
        features: []
      })
    }
  }

  renderActiveBorough(map, borough_filter, active_neighborhood) {
    if (borough_filter) {
      const borough_names = Boroughs.features.map(borough => borough.properties.borough);
      const borough_index = borough_names.indexOf(borough_filter);
      const borough_feature = Boroughs.features[borough_index];
      map.getSource('active_borough').setData({
        type: 'FeatureCollection',
        features: [borough_feature]
      });
      var input = {
        "type": "FeatureCollection",
        "features": [
          borough_feature
        ]
      }
      if (!active_neighborhood) {
        let box = extent(input);
        map.fitBounds(box, {padding: 100});
      }
    } else {
      map.getSource('active_borough').setData({
        type: 'FeatureCollection',
        features: []
      });
      if (!active_neighborhood) {
        const nyc_bounds = [[-74.27643833007856, 40.48198566721396],[-73.65160461861605, 40.92793497349999]];
        map.fitBounds(nyc_bounds, {padding: 0});
      }
    }
  }

  renderActiveNeighborhood(map, active_neighborhood, browser_width) {
    if (active_neighborhood) {
      map.getSource('active').setData({
        type: 'FeatureCollection',
        features: [active_neighborhood]
      });
      const box = this.getBoundingBox(active_neighborhood);
      if (browser_width < 451) {
        map.fitBounds(box, {padding: 20});
      } else if (browser_width < 1000) {
        map.fitBounds(box, {padding: 100});
      } else {
        map.fitBounds(box, {padding: 200});
      }
    } else {
      map.getSource('active').setData({
        type: 'FeatureCollection',
        features: []
      });
      const nyc_bounds = [[-74.27643833007856, 40.48198566721396],[-73.65160461861605, 40.92793497349999]];
      map.fitBounds(nyc_bounds, {padding: 0});
    }
  }

  renderActiveHex(map, active_hex) {
    if (active_hex) {
      map.getSource('active_hex').setData({
        type: 'FeatureCollection',
        features: [active_hex]
      });
    } else {
      map.getSource('active_hex').setData({
        type: 'FeatureCollection',
        features: []
      });
    }
  }

  changeStyle(map, show_roads) {
    if (show_roads) {
      map.setLayoutProperty('road_major_label', 'visibility', 'visible');
      map.setLayoutProperty('road_major', 'visibility', 'visible');
      map.setLayoutProperty('road_minor', 'visibility', 'visible');
      map.setLayoutProperty('water', 'visibility', 'visible');
      map.setLayoutProperty('waterway', 'visibility', 'visible');
      map.setLayoutProperty('landuse_park', 'visibility', 'visible');
      map.setLayoutProperty('landuse_overlay_national_park', 'visibility', 'visible');
      map.setLayoutProperty('boroughs', 'visibility', 'none');
      map.setPaintProperty('background', 'background-color', '#fafafa');
    } else {
      map.setLayoutProperty('road_major_label', 'visibility', 'none');
      map.setLayoutProperty('road_major', 'visibility', 'none');
      map.setLayoutProperty('road_minor', 'visibility', 'none');
      map.setLayoutProperty('water', 'visibility', 'none');
      map.setLayoutProperty('waterway', 'visibility', 'none');
      map.setLayoutProperty('landuse_park', 'visibility', 'none');
      map.setLayoutProperty('landuse_overlay_national_park', 'visibility', 'none');
      map.setLayoutProperty('landuse_overlay_national_park', 'visibility', 'none');
      map.setLayoutProperty('boroughs', 'visibility', 'visible');
      map.setPaintProperty('background', 'background-color', '#ddd');
    }
  }

  componentDidMount() {
    const {active_year, active_neighborhood, neighborhoods, show_roads, neighborhoods_samples} = this.props;
    mapboxgl.accessToken = 'pk.eyJ1IjoiZ3JhbnRjdXN0ZXIiLCJhIjoicWt3cWdQYyJ9.BK1_BsLvjxlLULMdWCnQuA';
    ;
    let style = 'mapbox://styles/grantcuster/cixrnpgmo000p2rkl0razqdxw';
    if (show_roads) style = 'mapbox://styles/grantcuster/cipu6plcg0003bpmb5hq7ofro';
    const map = new mapboxgl.Map({
      container: 'Map',
      style: style,
      center: [-73.94616184082079, 40.710718089480224],
      zoom: 9,
      maxZoom: 15,
      bearing: 0,
      attributionControl: false,
      maxBounds: [[-74.94, 40.11], [-72.94, 41.31]]
    }).on('load', () => {
      this.props.mapLoaded(map);
      map.addControl(new mapboxgl.NavigationControl({position: 'top-right'}));
      map.addControl(new mapboxgl.AttributionControl());
      this.addBoroughsLayer(map);
      this.props.getNeighborhoodsSamples(active_year);
    })
    map.dragRotate.disable()
    map.touchZoomRotate.disableRotation();
  }

  componentDidUpdate(prevProps) {
    const {
      neighborhoods_samples: p_neighborhoods_samples,
      active_mode: p_active_mode,
      active_price: p_active_price,
      active_year: p_active_year,
      active_probability: p_active_probability,
      active_neighborhood: p_active_neighborhood,
      hexes: p_hexes,
      active_hex: p_active_hex,
      show_roads: p_show_roads,
      borough_filter: p_borough_filter
    } = prevProps;
    const {
      map,
      neighborhoods_samples,
      neighborhoods,
      active_mode,
      active_price,
      active_year,
      active_probability,
      active_neighborhood,
      hexes,
      active_hex,
      show_roads,
      browser_width,
      borough_filter
    } = this.props;
    // Init neighborhoods (add the layer) the first time we get them
    if (p_neighborhoods_samples === false && neighborhoods_samples !== false) {
      this.addNeighborhoodsLayer(map, browser_width);
    }
    if (neighborhoods_samples) {
      // Change paint on mode change
      if (p_active_mode !== active_mode) {
        const paint = this.getPaint(active_mode);
        map.setPaintProperty('neighborhoods_layer', 'fill-color', paint);
        map.setPaintProperty('hexes_layer', 'fill-color', paint);
      }
      if (p_active_mode !== active_mode || p_active_price !== active_price || p_active_probability !== active_probability || p_active_year !== active_year) {
        map.getSource('neighborhoods').setData({
          type: 'FeatureCollection',
          features: neighborhoods
        })
      }
    }
    if (p_active_neighborhood !== active_neighborhood) {
      if (active_neighborhood) {
        this.props.getNeighborhoodHexes(active_neighborhood.properties.neighborhood);
      }
      this.renderActiveNeighborhood(map, active_neighborhood, browser_width);
    }
    let mobile = false;
    if (browser_width < 451) mobile = true;
    if (p_hexes !== hexes) {
      this.renderHexes(map, hexes);
      if (active_hex) {
        this.renderActiveHex(map, active_hex)
      }
    }
    if (p_active_hex !== active_hex) {
      this.renderActiveHex(map, active_hex);
    }
    if (p_show_roads !== show_roads) {
      this.changeStyle(map, show_roads)
    }
    if (p_borough_filter !== borough_filter) {
      this.renderActiveBorough(map, borough_filter, active_neighborhood);
    }
  }

  render() {
    const {map, neighborhoods, formatters, active_mode, interpolators, browser_width} = this.props;
    const {hover_info} = this.state;
    let mobile = false;
    if (browser_width < 451) mobile = true;
    return(
      <div>
        <div id="Map" onMouseLeave={this.handleMouseLeave.bind(this)}></div>
        {map && hover_info && !mobile ? (
          <HoverInfo
            active_mode={active_mode}
            hover_info={hover_info}
            formatters={formatters}
            interpolators={interpolators}
            browser_width={browser_width}
          />
        ) : null}
      </div>
    )
  }
}

export default Map;



/** WEBPACK FOOTER **
 ** ./src/components/Map.js
 **/